module.exports = __webpack_public_path__ + "static/media/right.8f532112.svg";